import comp from "./SimilarityIndexComponent";
export default comp;
